import { createContext } from 'react'

import SettingsStore from 'stores/SettingsStore'

const SettingsStoreContext = createContext<SettingsStore>(new SettingsStore())

export default SettingsStoreContext
